export type ProviderSettings = {
  [key: string]: Provider;
};

export enum LG_LAUNCH_PARAMS_METHOD {
  contentTarget = 'contentTarget',
  values = 'values',
}

export type Provider = {
  enabled?: boolean;
  activationUrl?: string;
  shortActivationUrl?: string;
  metaKey: string;
  metaValue: string;
  providerImageUrl: string;
  supportPhone: string;
  showPopupBeforePlayback: boolean;
  iOsStore?: string;
  androidTVStore?: string;
  androidStore?: string;
  lgStore?: string;
  tizenStore?: string;
  appPackageName?: string;
  alternativeIconName?: string;
  code?: string;
  fullActivationUrl?: string;
  title?: string;
  lgAppPackageName?: string;
  samsungAppPackageName?: string;
  devicesNotAllowedDeepLinkBrandIds?: string;
  devicesNotAllowedGoDirectlyToStoreBrandIds?: string;
  isConfigured?: boolean;
  displayName: string;
  userDynamicDataCodeKey: string;
  lgLaunchParamsMethod?: LG_LAUNCH_PARAMS_METHOD;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const normalizingProviderData = (provider: any): Provider => ({
  activationUrl: provider.activationUrl || '',
  shortActivationUrl: provider.shortActivationUrl || '',
  metaKey: provider?.metaKey,
  metaValue: provider.metaValue,
  providerImageUrl: provider.providerImageUrl || '',
  supportPhone: provider.supportPhone || '',
  iOsStore: provider.iOsStore,
  androidTVStore: provider.androidTVStore,
  androidStore: provider.androidStore,
  lgStore: provider.lgStore,
  tizenStore: provider.tizenStore,
  appPackageName: provider.appPackageName,
  alternativeIconName: provider.alternativeIconName || '',
  lgAppPackageName: provider.lgAppPackageName || '',
  samsungAppPackageName: provider.samsungAppPackageName || '',
  devicesNotAllowedDeepLinkBrandIds: provider.DevicesNotAllowedDeepLinkBrandIds || '',
  devicesNotAllowedGoDirectlyToStoreBrandIds: provider.DevicesNotAllowedGoDirectlyToStoreBrandIds || '',
  enabled: provider.enabled || false,
  showPopupBeforePlayback: provider.showPopupBeforePlayback || false,
  userDynamicDataCodeKey: provider.userDynamicDataCodeKey || '',
  displayName: provider.displayName || '',
  lgLaunchParamsMethod: provider.lgLaunchParamsMethod || undefined,
});

interface PreparedProviders {
  [key: string]: Provider;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const prepareProviders = (providers: ProviderSettings, normalizingFunction: any) => {
  return Object.keys(providers).reduce((sum: PreparedProviders, providerName) => {
    sum[providerName] = normalizingFunction(providers[providerName]);
    return sum;
  }, {});
};
